<template>
  <b-modal ref="my-modal" title="System Message" @ok="setVisible">
    <p class="mb-0">{{ getModalMessage }}</p>
    <small v-if="getModalSubMessage">{{ getModalSubMessage }}</small>
    <div style="height: 10px;"></div>
  </b-modal>
</template>

<script>
export default {
  name: "Modal",

  computed: {
    getModalMessage() {
      return this.$store.getters["systemMessage/getModalMessage"];
    },
    getModalSubMessage() {
      return this.$store.getters["systemMessage/getModalSubMessage"];
    },
    visible() {
      return this.$store.state.systemMessage.visible;
    },
  },
  watch: {
    getModalMessage(getModalMessage) {
      if (getModalMessage) {
        this.$refs["my-modal"].show();
      } else if (!getModalMessage) {
        this.$refs["my-modal"].hide();
      }
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.$store.dispatch("systemMessage/setModalMessage", {
        message: "",
      });
    });
  },
  methods: {
    doSomethingOnHidden() {
      console.log("evenet trigerred");
    },
    setVisible() {
      setTimeout(() => {
        this.$store.commit("systemMessage/SET_VISIBLE", false);
      }, 250);
    },
  },
};
</script>

<style>
.modal-header {
  padding: 1rem 1rem !important;
}
.modal-body {
  padding: 0rem 0rem 0 2rem !important;
}
</style>
